import React from "react";
import { Row } from "react-bootstrap";
import id from "@irati/utils/id";
import StyledCol from "./styled/Col";
var LoginBlock = function (props) {
    var children = props.children, size = props.size;
    var idNamespace = id("login-block", props);
    return (React.createElement(Row, { id: idNamespace },
        React.createElement(StyledCol, { id: id("col", idNamespace), xs: 12, size: size }, children)));
};
LoginBlock.defaultProps = {
    size: "small"
};
export default LoginBlock;
